import React, { useContext } from 'react';
import { Button, Popconfirm, Table, Tag, Image, Tooltip } from 'antd';
import { IRegion, Itrim } from 'types/index';
import { observer } from 'mobx-react';
import { rootContext } from 'stores';
import {
  DeleteFilled,
  RollbackOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';
import SvgRenderer from 'components/Svgrendere/Svgrendere';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
dayjs.extend(calendar)

const Parts: React.FC = observer(() => {
  const {
    RecycleStore: {
      state: {
        data: { parts, total, offset, limit, search },
        ui: { recyclerLoading }
      },
      getAllDeletedItems,
      deleteItemForever,
      restoreItems
    }
  } = useContext(rootContext);

  const renderTags = (value: any[], row: any) => {
    return value?.length < 1 ? (
      <Tag>No Sub Models</Tag>
    ) : (
      value?.map(item => (
        <div className="subModelContainer">
          <Tag>{item.submodel}</Tag>
          <div className="tableImage">
            <Image src={item?.url || ''} alt={row.name} />
          </div>
        </div>
      ))
    );
  };

  return (
    <Table
      className="Table_block_main"
      columns={[
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name'
          // sorter: true
        },
        {
          title: 'Brand',
          dataIndex: ['Brand.brand'],
          key: 'brand',

          render: value => value
        },
        {
          title: 'Region',
          dataIndex: 'region',
          key: 'region',

          render: (value: IRegion[]) =>
            value.map((item: IRegion) => <Tag>{item.name}</Tag>)
        },
        {
          title: 'Model',
          dataIndex: 'model',
          key: 'model',
          render: (value: string, record: any, index: number) => (
            <>
              <div className="subModelContainer">
                <Tag>{value}</Tag>
                {record?.model_image && (
                  <div className="tableImage">
                    <Image src={record.model_image} alt={record.model_image} />
                  </div>
                )}
              </div>
            </>
          ),
          align: 'left'
        },
        {
          title: 'Submodels',
          dataIndex: 'submodel',
          key: 'submodel',
          render: renderTags
        },
        {
          title: 'Trims',
          dataIndex: 'series',
          key: 'series',
          render: (value: any[], row: any) => {
            let trimsArray: Itrim[] = [];
            row?.submodel?.forEach((sub:any) => {
              sub?.trim?.forEach((t:any) => {
                trimsArray.push(t);
              });
            });
            return trimsArray?.length < 1 ? (
              <Tag> No Trims </Tag>
            ) : (
              trimsArray?.map(item => (
                <div className="subModelContainer">
                  <Tag>{item.name}</Tag>
                  <div className="tableImage">
                    <Image src={item.image} alt={item.name} />
                  </div>
                </div>
              ))
            );
          }
        },
        {
          title: 'Pattern Type',
          align: 'center',
          dataIndex: 'pattern_type',
          key: 'pattern_type',
          render: value => value
          // sorter: true
        },
        {
          title: 'Start Year',
          align: 'center',
          dataIndex: 'startMakingYear',
          key: 'startMakingYear',
          render: value => value
          // sorter: true
        },
        {
          title: 'End Year',
          align: 'center',
          dataIndex: 'endMakingYear',
          key: 'endMakingYear',
          render: value => value
          // sorter: true
        },
        {
          title: 'Part',
          align: 'center',
          dataIndex: 'url',
          key: 'file',
          render: (value:any, row: any) =>
            value ? (
              <SvgRenderer svgUrl={value} id={uuidv4()} title="View Part" />
            ) : (
              'No File'
            )
        },
        {
          title: 'Deleted Time',
          align: 'center',
          dataIndex: 'deletedAt',
          render: (value: string) => dayjs(value).calendar()
        },
        {
          title: 'Actions',
          align: 'center',
          width: 20,
          render: (_: any, record: any) => (
            <div className="actionButtons">
              <Tooltip title="Restore Part">
                <Button
                  type="default"
                  className="editButton"
                  onClick={() => {
                    restoreItems({ id: record.id, type: 'PART' });
                  }}
                >
                  <RollbackOutlined />
                </Button>
              </Tooltip>

              <Popconfirm
                autoAdjustOverflow
                placement="topRight"
                title={() => (
                  <p>
                    Delete this <b>Part</b>{' '}
                    <span style={{ color: 'red' }}>Permanently</span> ?
                  </p>
                )}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={async () => {
                  await deleteItemForever({ id: record?.id, type: 'PART' });
                }}
              >
                <Button ghost={true} className="deleteButton">
                  <DeleteFilled />
                </Button>
              </Popconfirm>
            </div>
          )
        }
      ]}
      loading={recyclerLoading}
      dataSource={parts}
      tableLayout="auto"
      rowKey="id"
      onChange={(pagination, _, sort) => {
        const { current = 1, pageSize = 10 } = pagination;
        getAllDeletedItems(search, pageSize, current, 'PART');
      }}
      pagination={{
        disabled: recyclerLoading,
        total: total,
        pageSize: limit,
        current: offset,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20']
      }}
    />
  );
});

export default Parts;
